<template>
	<section class="hero">
		<div class="hero__container">
			<GlobalImage
				loading="eager"
				class="hero__image"
				:alt="
					isElectricPageCase
						? $t('modules.departments_page_module.location_page_hero.electric_car_renatl')
						: $t('modules.departments_page_module.location_page_hero.car_rental', { city: cmsLocation?.[`name${locale.toUpperCase()}`] })
				"
				:src="bannerIMG ? `${storageUrl}${bannerIMG}` : locationHeroIMG"
				sizes="970px sm:1536px" />
			<h1 class="hero__title">
				<template v-if="isElectricPageCase">
					{{ $t('modules.departments_page_module.location_page_hero.electric_car_rental') }}
				</template>
				<template v-else-if="locale === 'pl' && locationType === 'airport'">
					{{
						$t('modules.departments_page_module.location_page_hero.car_rental_airport', {
							city: cmsLocation?.[`name${locale.toUpperCase()}`],
						})
					}}
				</template>
				<template v-else-if="locale === 'pl' && locationType === 'city'">
					{{
						$t('modules.departments_page_module.location_page_hero.car_rental_city', {
							city: cmsLocation?.[`name${locale.toUpperCase()}`],
						})
					}}
				</template>
				<template v-else-if="locale === 'pl' && locationType === 'delivery'">
					{{
						$t('modules.departments_page_module.location_page_hero.delivery_van_rental', {
							city: cmsLocation?.[`name${locale.toUpperCase()}`],
						})
					}}
				</template>
				<template v-else-if="locale === 'pl' && locationType === 'bus'">
					{{ $t('modules.departments_page_module.location_page_hero.bus_rental', { city: cmsLocation?.[`name${locale.toUpperCase()}`] }) }}
				</template>
				<template v-else>
					{{ $t('modules.departments_page_module.location_page_hero.car_rental', { city: cmsLocation?.[`name${locale.toUpperCase()}`] }) }}
				</template>
			</h1>
			<div class="hero__gradient"></div>
			<div class="hero__booker-container">
				<div class="hero__days-months-google-container">
					<GlobalBookerDaysMonths />
					<div class="hero__reviews-container">
						<LazyIdleLocationGoogleReviews hydrate-on-idle />
						<LazyIdleLocationTrustpilotReviews hydrate-on-idle />
					</div>
				</div>
				<div class="hero__global-booker-wrapper">
					<GlobalBookerFallback>
						<ClientOnly>
							<LazyGlobalBooker location />
						</ClientOnly>
					</GlobalBookerFallback>
				</div>
			</div>
			<LazyIdleGlobalBookerAdvantages hydrate-on-idle />
		</div>
	</section>
</template>

<script setup lang="ts">
const { locale } = useI18n()
const pageHeaderSection = inject<Ref<ICMSLocationContent>>('pageHeaderSection') || ref<ICMSLocationContent>([])
const cmsLocation = inject<Ref<ICMSLocation>>('cmsLocation') || ref<ICMSLocation>([])
const bannerIMG = ref<string>()
const route = useRoute()
const { storageUrl, locationHeroIMG } = useStorageService()

const isElectricPageCase = computed(() => route.fullPath.includes('wypozyczalnia-samochodow-elektrycznych'))

// mirrors the type detection in car-rental-[urlSlug]/index.vue's carGroupSwitch - order matters,
// 'wroclaw-bus-dostawczy' contains both 'dostawczy' and 'bus' so dostawczy must be checked first
const locationType = computed(() => {
	const link = cmsLocation.value?.urlPL
	if (!link) return null
	if (link.includes('elektrycznych') || link.includes('tesla')) return 'electric'
	if (link.includes('dostawczy')) return 'delivery'
	if (link.includes('bus')) return 'bus'
	if (link.includes('lotnisko')) return 'airport'
	return 'city'
})

const assignBannerIMG = () => {
	if (!pageHeaderSection.value) return null
	if (pageHeaderSection.value.files && pageHeaderSection.value.files.length > 0) {
		const img = pageHeaderSection.value.files[0].path
		if (img) bannerIMG.value = img
	}
}

assignBannerIMG()
</script>

<style scoped lang="scss" src="./PageHero.scss"></style>
